
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"16"}},[_c('path',{attrs:{"d":"M11.757 11.517L6.734 3.39c-.405-.654-1.063-.655-1.467 0L.244 11.517c-.543.878-.148 1.585.879 1.585h9.755c1.026 0 1.421-.709.879-1.585zM6 11.704a.465.465 0 1 1-.002-.93.465.465 0 0 1 .002.93zm.466-2.327a.467.467 0 0 1-.932 0V6.58c0-.253.208-.464.466-.464.259 0 .466.208.466.464v2.797z"}})])
      }
    
      }
    